<template>
  <div class="mayUse">
    <div
      class="daijin daijin2"
      v-for="unuseds in couponData.used"
      :key="unuseds.id"
    >
      <div class="daijin-top">
        <span class="money">
          <span class="money1" v-if="unuseds.couponUnit == 1">￥</span>
          <span class="money1" v-if="unuseds.couponUnit == 2">$</span>
          <span class="money2">{{ unuseds.couponLimit }}</span>
        </span>
        <span class="use">
          <!--<a-button type="primary" size="small">点击使用</a-button>-->
          <!--可使用-->
          <p>
            {{
              unuseds.couponSource === 'system' ? '首次系统分发' : '经理发放'
            }}
          </p>
        </span>
      </div>
      <div class="daijin-bottom">
        截止日期:
        <span>
          {{ $momentData(unuseds.couponEnddate) }}
        </span>
        <!--<span>2018-09-21</span>-->
      </div>
    </div>
    <!--   <div class="daijin daijin1">
      <div class="daijin-top">
        <span class="money">
          <span class="money1">￥</span>
          <span class="money2">5</span>
        </span>
        <span class="use">
          <a-button type="primary" size="small">点击使用</a-button>
          <p>注册获得</p>
        </span>
      </div>
      <div class="daijin-bottom">
        有效期
        <span>2016-07-02</span>
        至
        <span>2018-09-21</span>
      </div>
    </div>
    <div class="daijin daijin2">
      <div class="daijin-top">
        <span class="money">
          <span class="money1">￥</span>
          <span class="money2">5</span>
        </span>
        <span class="use">
          <a-button type="primary" size="small">点击使用</a-button>
          <p>注册获得</p>
        </span>
      </div>
      <div class="daijin-bottom">
        有效期
        <span>2016-07-02</span>
        至
        <span>2018-09-21</span>
      </div>
    </div>
    <div class="daijin daijin2">
      <div class="daijin-top">
        <span class="money">
          <span class="money1">￥</span>
          <span class="money2">5</span>
        </span>
        <span class="use">
          <a-button type="primary" size="small">点击使用</a-button>
          <p>注册获得</p>
        </span>
      </div>
      <div class="daijin-bottom">
        有效期
        <span>2016-07-02</span>
        至
        <span>2018-09-21</span>
      </div>
    </div>-->
  </div>
</template>
<script>
export default {
  name: 'used',
  data() {
    return {};
  },
  // 数据状态处理全局
  computed: {
    // 全部优惠卷数据
    couponData: {
      get() {
        return this.$store.state.expired.couponData;
      },
      set(value) {
        this.$store.commit('used/save', {
          couponData: value,
        });
      },
    },
  },
  created() {
    this.$store.dispatch('used/getCoupon');
  },
};
</script>
<style lang="less">
.mayUse {
  > div {
    display: inline-block;
  }
  height: calc(100vh - 270px);
  overflow-y: auto;
  .daijin {
    overflow: hidden;
    width: 373px;
    height: 125px;
    margin: 10px 5% 10px 0;
    // position: relative;
    .daijin-top {
      height: 80px;
      margin-left: 155px;
      margin-top: 20px;
      position: relative;
      > span {
        display: inline-block;
      }
      .money {
        color: #fff;
        .money1 {
          font-size: 34px;
        }
        .money2 {
          font-size: 54px;
        }
      }
      .use {
        margin-left: 36px;
        text-align: right;
        vertical-align: middle;
        position: absolute;
        bottom: 0;
        button {
          color: #0da3d6;
          background-color: #fff;
          border: none;
          font-size: 12px;
          margin-bottom: 5px;
        }
        p {
          font-size: 12px;
          color: #0da3d6;
          margin-bottom: 0;
        }
      }
    }
    .daijin-bottom {
      height: 25px;
      font-size: 12px;
      color: #0da3d6;
      text-align: right;
      margin-right: 10px;
    }
  }
  .daijin1 {
    background-image: url(../images/daijin.png);
    background-repeat: no-repeat;
  }
  .daijin2 {
    background-image: url(../images/daijin1.png);
    background-repeat: no-repeat;

    .daijin-top {
      .use {
        button {
          color: #b7b7b7;
        }
        p {
          font-size: 12px;
          color: #b7b7b7;
        }
      }
    }
    .daijin-bottom {
      color: #b7b7b7;
    }
  }
}
</style>
